import React, { memo } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import LoadingButton from "./loading-button.component";
import { Theme } from "@mui/material";

import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogPaper: {
      zIndex: 999,
    },
  }),
);

const ConfirmDialog = memo(
  ({
    text,
    actionText = "Delete",
    cancelText = "Cancel",
    isLoading = false,
    open,
    onClose,
    action,
  }: {
    text: string | undefined;
    actionText?: string | undefined;
    cancelText?: string | undefined;
    open: boolean;
    isLoading?: boolean;
    onClose: () => void;
    action: () => any;
  }) => {
    const classNames = useStyles();

    return (
      <Dialog
        open={open}
        onClose={() => onClose()}
        classes={{
          paper: classNames.dialogPaper,
        }}
      >
        <DialogContent>
          <DialogContentText textAlign="center">
            <Typography component="span">{text}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <LoadingButton
            text={actionText}
            isLoading={isLoading}
            onClick={action}
            color="success"
            variant="outlined"
          />
          <Button onClick={() => onClose()} autoFocus variant="outlined">
            {cancelText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default ConfirmDialog;
